export default () => ({
  button: {
    borderColor: 'white',
    color: 'white',
    marginLeft: 8,
  },
  container: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    bottom: 0,
    padding: 10,
    position: 'absolute',
    zIndex: 2000,
  },
});
